import advisorImage from '@/assets/images/advisor-mini.png'
import TerritoryActiveImg from '@/components/Advisors/TerritoryActiveImg'
import {Stack, Typography} from '@mui/material'
import React from 'react'
import {AdvisorInterface} from '@/types/types'
import {colors} from '@/constants'

const Index = ({
  advisor,
}: {
  advisor: {
    id: number
    hex_count: number
    subscription_status: 'ACTIVE' | 'PAID' | 'PAUSED' | null | undefined
    is_hibernated: boolean
  }
}) => {
  return (
    <Stack data-tooltip-id={'advisor-' + advisor.id} position="relative">
      <img
        alt=""
        src={advisorImage}
        style={{opacity: advisor.hex_count === 0 ? 0.4 : 1}}
      />
      <TerritoryActiveImg status={advisor.subscription_status} />
      {advisor.is_hibernated && (
        <Typography
          fontWeight="700"
          className="middle-absolute"
          color={colors.orange}>
          H
        </Typography>
      )}
    </Stack>
  )
}

export default Index
